import {FETCH_FREQ, FETCH_FREQ_SUCCESS, FETCH_FREQ_ERROR, UPDATE_FREQ, UPDATE_FREQ_SUCCESS, UPDATE_FREQ_ERROR, RESET_UPDATE_FREQ} from 'constants/ActionTypes'

const INIT_STATE = {
  error: '',
  loading: false,
  updating: false,
  data: [],
  payload: {},
};

export default (state = INIT_STATE, action) => {
  switch (action.type) {
    case FETCH_FREQ: {
      return {...state, error: '', loading: true, payload: {}};
    }
    case UPDATE_FREQ: {
      return {...state, error: '', updating: true};
    }
    case FETCH_FREQ_SUCCESS: {
      return {...state, error: '', data: action.payload, loading: false};
    }
    case UPDATE_FREQ_SUCCESS: {
      return {...state, error: '', payload: { code: 200, message: 'Cập nhật dữ liệu thành công!' }, updating: false};
    }
    case FETCH_FREQ_ERROR: {
      return {...state, loading: false, error: action.payload};
    }
    case UPDATE_FREQ_ERROR: {
      return {...state, updating: false, error: action.payload, payload: { code: 500, message: 'Có lỗi trong quá trình xử lý!' }};
    }
    case RESET_UPDATE_FREQ: {
      return {...state, payload: {}};
    }
    default:
      return state;
  }
}
